import { render, staticRenderFns } from "./webUrlConfig.vue?vue&type=template&id=25848e08"
import script from "./webUrlConfig.vue?vue&type=script&lang=js"
export * from "./webUrlConfig.vue?vue&type=script&lang=js"
import style0 from "./webUrlConfig.vue?vue&type=style&index=0&id=25848e08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports